// export const SITE_ADDRESS = 'http://localhost:5000/';
// export const SITE_ADDRESS = 'https://sekolahmakarios.info/';
export const SITE_ADDRESS = process.env.REACT_APP_URL;
export const SITE_ADDRESS_PEMBELAJARAN = process.env.REACT_APP_URL_PEMBELAJARAN;
export const OLD_ADDRESS = 'http://202.43.173.27:3380/';